exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-stat-panel .checkbox-stat-box>.value{max-width:160px}", ""]);

// exports
